module.exports = __webpack_public_path__ + "static/media/bottom_banner_11_2.a59cd9c0.png";